import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react' 
import { GiCancel } from 'react-icons/gi'
type ModalProps = {
  show : boolean
  title?: String
  body?: String
  children?: JSX.Element
  cancelText?: String
  okText?: String
  okAction?: () => void
  cancelAction?: () => void
  onHide: () => void
  okTheme?: String,
  okMoreStyles?: String,
  loading?: boolean,
  fullWidth?: boolean,
  maxWidth?: String,
  okDisable?: boolean,
  disableClickOutsite?: boolean
  showCloseButton?: boolean,
  subTitle?: string,
  TitleIcon?: React.ElementType
}

const Modal = ({ 
  show = false, 
  title = '',
  body = '',
  children,
  cancelText = '',
  okText = '',
  okAction,
  onHide,
  okTheme,
  cancelAction,
  okMoreStyles = '',
  loading = false,
  fullWidth = false,
  maxWidth = 'max-w-md',
  okDisable = false,
  disableClickOutsite = false,
  showCloseButton = false,
  subTitle = '',
  TitleIcon
} : ModalProps) => {

  let completeButtonRef = useRef(null)
  
  function closeModal() {
    if(!disableClickOutsite) onHide()
  }

  let okStyle = 'justify-center px-4 py-2 text-md font-medium text-white bg-blue-500 rounded hover:bg-blue-600 disabled:bg-opacity-60'
  if (okTheme === 'success') {
    okStyle = ' btn-success px-4 py-2 text-md'
  } else if (okTheme === 'danger') {
    okStyle = ' btn-danger px-4 py-2 text-md'
  } else if (okTheme === 'secondary') {
    okStyle = ' btn-secondary px-4 py-2 text-md'
  } else if (okTheme === 'info') {
    okStyle = ' btn-info px-4 py-2 text-md'
  }
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog
        initialFocus={completeButtonRef}
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={closeModal}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 transition-opacity bg-black bg-opacity-30" />
          </Transition.Child>
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className={`inline-block w-full ${fullWidth ? '': maxWidth} p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl`}>
              <Dialog.Title
                as="h5"
                className="flex items-center justify-between pb-5 font-bold leading-6 text-gray-900"
              >
                <div className='flex items-center gap-2'>
                  {TitleIcon && <TitleIcon size={24} />}
                  <div className='flex flex-col gap-1 '>
                    {title}
                    {subTitle && <span className="text-xs italic font-light text-muted">{subTitle}</span>}
                  </div>
                </div>
                {showCloseButton && <button title='close' onClick={onHide}>
                  <GiCancel className=' text-slate-400' />
                </button>}
              </Dialog.Title>
              <div className="mt-2">
                {body ? <p className="text-gray-500 text-md">{body}</p> : null}
                {children}
              </div>
              <div className="mt-4 text-right">
                <button
                  type="button"
                  className={`${cancelText ? 'inline-flex' : 'hidden'} justify-center px-3 py-2 text-md font-medium text-gray-500 border border-gray-500 rounded hover:bg-gray-200`}
                  onClick={cancelAction ? cancelAction : closeModal}
                >
                  {cancelText}
                </button>
                <button
                  type="button"
                  className={`${okText ? 'inline-flex' : 'hidden'} ml-2 ${okStyle} ${okMoreStyles}`}
                  onClick={okAction}
                  disabled={loading || okDisable}
                  ref={completeButtonRef}
                >
                  {loading ? `กำลัง${okText}...`: okText}
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal